export const TIMES_OF_DAY = [
  {
    id: 'NONE',
    name: '',
  },
  {
    id: 'WEEKDAY_MORNINGS',
    name:
      /* TRANSLATORS: time of day */
      getText('Weekday Mornings'),
  },
  {
    id: 'WEEKDAY_AFTERNOONS',
    name:
      /* TRANSLATORS: time of day */
      getText('Weekday Afternoons'),
  },
  {
    id: 'WEEKDAY_EVENINGS',
    name:
      /* TRANSLATORS: time of day */
      getText('Weekday Evenings'),
  },
  {
    id: 'WEEKDAYS',
    name:
      /* TRANSLATORS: time of day */
      getText('Weekdays'),
  },
];
